import React, { useEffect, useRef } from "react";

const Select = ({
    data = [],                                    // 드롭다운 항목: [{label, value}]
    bind = {},                                    // 전체 상태 객체
    setBind = () => {},                           // 전체 상태 객체의 set 함수
    id,                                           // bind의 key 역할
    label = "label",                              // data 배열에서 label 컬럼 명
    value = "value",                              // data 배열에서 value 컬럼 명
    onChange = () => {},                          // 변경시 발생 이벤트
    width = 'auto',                               // 정수형 width prop
    minWidth = 0,                                 // 정수형 minWidth prop
    filterTrigger = null,                         // 기준 값
    readOnly = false,                             // 읽기 전용 여부
    filter = (item, trigger) => true              // 필터 조건 함수
}) => {

    // 최초 로딩시 세팅 검증 
    const initializedRef = useRef(true);

    useEffect(() => {
        const filteredData = data.filter(d => filterTrigger ? filter(d, filterTrigger) : true)
      
        // 현재 선택된 값이 필터링된 리스트에 없으면 초기화
        if (!filteredData.find(d => d[value] === bind[id]) && filteredData.length > 0) {
          setBind(prev => ({
            ...prev,
            [id]: filteredData[0][value]
          }))
        }
      }, [filterTrigger, data])

    const handleChange = (e) => {
        const selectedValue = e.target.value;

        setBind(prev => ({
            ...prev,
            [id]: selectedValue
        }));

        onChange({ id, value: selectedValue });
    };

    // 필터링된 데이터만 렌더링
    const filteredData = data.filter(d =>
        filterTrigger ? filter(d, filterTrigger) : true
    )
    
    const computedWidth =
        typeof width === "number"
            ? `${width}px`
            : /^[0-9]+$/.test(width)
            ? `${width}px`
            : width; // "200px", "50%", "auto" 등 문자열 단위 명시 시 그대로 적용

    return (
        <select 
            value={bind[id] || ""} 
            onChange={handleChange} 
            required
            disabled={readOnly} 
            style={{ minWidth
                , width: computedWidth 
                , backgroundColor: readOnly ? '#f5f5f5' : 'white'
                , color: readOnly ? '#999' : 'inherit'
            }}
        >
            {filteredData.map(opt => (
                <option key={opt[value]} value={opt[value]}>
                    {opt[label]}
                </option>
            ))}
        </select>
    );
};

export default Select;
